import { InputHTMLAttributes, forwardRef } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  required?: boolean;
  className?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, required = false, id, className, ...rest }, ref) => {
    return (
      <div>
        <label
          htmlFor={id}
          className="block text-[#1E1E1E] text-[14px] font-[500] mb-1"
        >
          {label}
          {required && <span className="text-[#DC2626]">*</span>}
        </label>
        <div className="mb-[16px]">
          <input
            id={id}
            ref={ref}
            className={`w-full h-[42px] px-3 border ${
              error ? "border-[#FF3B30]" : "border-[#E0E0E0]"
            } text-[14px] font-[400] rounded-[6px] focus:outline-none focus:border-[#73B5C5] placeholder:text-[#B3B3B3] ${className}`}
            {...rest}
          />
          {error && (
            <p className="mt-0 text-[12px] font-[500] text-[#FF3B30]">
              {error}
            </p>
          )}
        </div>
      </div>
    );
  }
);

export default Input;
